import React, { ComponentProps } from 'react'

import { overrideOptional } from '@emico/overrides'
import { ProductCardFragment } from '@emico/product-card-fragment'

import Price from './Price'

type PriceProps = Omit<ComponentProps<typeof Price>, 'value' | 'currency'>

interface Props extends PriceProps {
  product: ProductCardFragment
}

const ProductCardPrice = ({ product, ...props }: Props) => {
  if (!product.priceRange.minimumPrice.finalPrice) {
    return null
  }

  return (
    <Price
      value={product.priceRange.minimumPrice.finalPrice.value}
      currency={product.priceRange.minimumPrice.finalPrice.currency}
      {...props}
    />
  )
}

export default overrideOptional(ProductCardPrice)
